// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 94 ? "pdfjsWorker" : chunkId) + "." + {"94":"6ea14ead","428":"5bf4c643","635":"ba454000","787":"5a4bc5ed"}[chunkId] + ".chunk.js";
};